<app-breadcrumb [title]="'Checkout'" [breadcrumb]="'Checkout'"></app-breadcrumb>
<section class="section-b-space">
    <div class="container">
      <div class="checkout-page">
        <div class="checkout-form">
          <form (ngSubmit)="placeOrder()" [formGroup]="checkoutForm">
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <div class="checkout-title">
                  <h3>Billing Details</h3>
                </div>
                <div class="row check-out">
                  <!-- First Name Field -->
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <div class="field-label">First Name</div>
                    <input type="text" formControlName="firstname" placeholder="Enter your first name" autocomplete="off" />
                    <div *ngIf="checkoutForm.get('firstname')?.touched && checkoutForm.get('firstname')?.hasError('required')" class="text text-danger">
                      First Name is required.
                    </div>
                    <div *ngIf="checkoutForm.get('firstname')?.touched && checkoutForm.get('firstname')?.hasError('pattern')" class="text text-danger">
                      First Name must only contain alphabets.
                    </div>
                  </div>
                  <!-- Last Name Field -->
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <div class="field-label">Last Name</div>
                    <input type="text" formControlName="lastname" placeholder="Enter your last name" autocomplete="off" />
                    <div *ngIf="checkoutForm.get('lastname')?.touched && checkoutForm.get('lastname')?.hasError('required')" class="text text-danger">
                      Last Name is required.
                    </div>
                    <div *ngIf="checkoutForm.get('lastname')?.touched && checkoutForm.get('lastname')?.hasError('pattern')" class="text text-danger">
                      Last Name must only contain alphabets.
                    </div>
                  </div>
                  <!-- Phone Field -->
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <div class="field-label">Phone</div>
                    <input type="text" formControlName="phone" placeholder="Enter your phone number" autocomplete="off" />
                    <div *ngIf="checkoutForm.get('phone')?.touched && checkoutForm.get('phone')?.hasError('required')" class="text text-danger">
                      Phone number is required.
                    </div>
                    <div *ngIf="checkoutForm.get('phone')?.touched && checkoutForm.get('phone')?.hasError('pattern')" class="text text-danger">
                      Phone number must only contain numbers.
                    </div>
                  </div>
                  <!-- Email Field -->
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <div class="field-label">Email Address</div>
                    <input type="text" formControlName="email" placeholder="Enter your email address" autocomplete="off" />
                    <div *ngIf="checkoutForm.get('email')?.touched && checkoutForm.get('email')?.hasError('required')" class="text text-danger">
                      Email is required.
                    </div>
                    <div *ngIf="checkoutForm.get('email')?.touched && checkoutForm.get('email')?.hasError('email')" class="text text-danger">
                      Invalid email address.
                    </div>
                  </div>
                  <!-- Country Field -->
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <div class="field-label">Country</div>
                    <input type="text" formControlName="country" placeholder="Enter your country" autocomplete="off" />
                    <div *ngIf="checkoutForm.get('country')?.touched && checkoutForm.get('country')?.hasError('required')" class="text text-danger">
                      Country is required.
                    </div>
                  </div>
                  <!-- Address Field -->
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <div class="field-label">Address</div>
                    <input type="text" formControlName="address" placeholder="Enter your address" autocomplete="off" />
                    <div *ngIf="checkoutForm.get('address')?.touched && checkoutForm.get('address')?.hasError('required')" class="text text-danger">
                      Address is required.
                    </div>
                    <div *ngIf="checkoutForm.get('address')?.touched && checkoutForm.get('address')?.hasError('maxlength')" class="text text-danger">
                      Maximum 50 characters allowed.
                    </div>
                  </div>
                  <!-- Town/City Field -->
                  <div class="form-group col-md-12 col-sm-12 col-xs-12">
                    <div class="field-label">Town/City</div>
                    <input type="text" formControlName="town" placeholder="Enter your town/city" autocomplete="off" />
                    <div *ngIf="checkoutForm.get('town')?.touched && checkoutForm.get('town')?.hasError('required')" class="text text-danger">
                      Town/City is required.
                    </div>
                  </div>
                  <!-- State Field -->
                  <div class="form-group col-md-12 col-sm-6 col-xs-12">
                    <div class="field-label">State</div>
                    <input type="text" formControlName="state" placeholder="Enter your state" autocomplete="off" />
                    <div *ngIf="checkoutForm.get('state')?.touched && checkoutForm.get('state')?.hasError('required')" class="text text-danger">
                      State is required.
                    </div>
                  </div>
                  <!-- Postal Code Field -->
                  <div class="form-group col-md-12 col-sm-6 col-xs-12">
                    <div class="field-label">Postal Code</div>
                    <input type="text" formControlName="postalcode" placeholder="Enter your postal code" autocomplete="off" />
                    <div *ngIf="checkoutForm.get('postalcode')?.touched && checkoutForm.get('postalcode')?.hasError('required')" class="text text-danger">
                      Postal code is required.
                    </div>
                  </div>
                </div>
              </div>

              <!-- Order Summary and Payment Options -->
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <div class="checkout-details">
                  <!-- Order Box -->
                  <div class="order-box">
                    <div class="title-box">
                      <div>Product <span> Total</span></div>
                    </div>
                    <ul class="qty" *ngIf="products.length">
                      <li *ngFor="let product of products">
                        {{ product.name }} × {{ product.quantity }}
                        <span>
                          {{ (product.price | discount: product) * productService?.Currency.price | currency: productService?.Currency.currency: 'symbol' }}
                        </span>
                      </li>
                    </ul>
                    <ul class="qty" *ngIf="!products.length">
                      <li class="empty-checkout">There are no products in the cart.</li>
                    </ul>
                    <ul class="sub-total">
                      <li>
                        Subtotal <span class="count">{{ getTotal | async | currency: productService?.Currency.currency: 'symbol' }}</span>
                      </li>
                    </ul>
                    <ul class="total">
                      <li>
                        Total <span class="count">{{ getTotal | async | currency: productService?.Currency.currency: 'symbol' }}</span>
                      </li>
                    </ul>
                  </div>

                  <!-- Payment Box -->
                  <div class="payment-box" *ngIf="products.length">
                    <div class="upper-box">
                      <div class="payment-options">
                        <!-- <ul>
                          <li>
                            <div class="radio-option">
                              <input type="radio" [(ngModel)]="payment" [value]="'Stripe'" name="payment-group" id="payment-2" />
                              <label for="payment-2">Stripe
                                <span class="small-text">Please provide Stripe details at checkout.</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div class="radio-option paypal">
                              <input type="radio" [(ngModel)]="payment" [value]="'Paypal'" name="payment-group" id="payment-3" />
                              <label for="payment-3">PayPal
                                <span class="image"><img src="assets/images/paypal.png" alt="PayPal" /></span>
                              </label>
                            </div>
                          </li>
                        </ul> -->
                      </div>
                    </div>
                    <div class="mb-4">
                      <label for="card-element">Credit or Debit Card</label>
                      <div id="card-element" class="card-element-style"></div>
                    </div>
                    <div class="text-end">
                      <button type="submit" class="btn-solid btn" [disabled]="!checkoutForm.valid || processing" *ngIf="payment === 'Stripe'">
                        Place Order
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
